import { Table } from "reactstrap";
import { P } from "../../../../../AbstractElements";

const InvoiceDateSection = () => {
  return (
    <tr>
      <td className="p-0">
        <Table style={{ width: "100%", borderSpacing: 4, marginBottom: 20 }}>
          <tbody>
            <tr>
              <td style={{ padding: "15px 25px" }}>
                <P style={{ fontSize: 16, fontWeight: 500, opacity: "0.8", margin: 0, lineHeight: 2 }}>Date :</P>
                <span style={{ fontSize: 18, fontWeight: 600 }}>10 Mar, 2025</span>
              </td>
              <td style={{ padding: "15px 25px" }}>
                <P style={{ fontSize: 16, fontWeight: 500, opacity: "0.8", margin: 0, lineHeight: 2 }}>Invoice No :</P>
                <span style={{ fontSize: 18, fontWeight: 600 }}>#VL25000365</span>
              </td>
              <td style={{ padding: "15px 25px" }}>
                <P style={{ fontSize: 16, fontWeight: 500, opacity: "0.8", margin: 0, lineHeight: 2 }}>Account No :</P>
                <span style={{ fontSize: 18, fontWeight: 600 }}>0981234098765</span>
              </td>
              <td style={{ padding: "15px 25px" }}>
                <P style={{ fontSize: 16, fontWeight: 500, opacity: "0.8", margin: 0, lineHeight: 2 }}>Due Amount :</P>
                <span style={{ fontSize: 18, fontWeight: 600 }}>$7860.00 </span>
              </td>
            </tr>
          </tbody>
        </Table>
      </td>
    </tr>
  );
};

export default InvoiceDateSection;
